import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'da';
    document.title = 'MATEMATIK KLAR™ – Færdige matematiklektioner til 0.–9. klasse';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3mjzsl4a6121a">
      <div lang="da" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3rc9e8848zfxr">
        <CountdownBar data-id="element-2" data-mp="3relv0hy9rk98" />
        <main data-id="element-3" data-mp="6hqtghuuhen">
          <Hero data-id="element-4" data-mp="680frswe88f" />
          <StatsBar data-id="element-5" data-mp="4n6o4eeqtbm" />
          <Difference data-id="element-6" data-mp="56qxrrj5tst" />
          <Recognize data-id="element-7" data-mp="2zl3bdjx5744s" />
          <WhatsInside data-id="element-8" data-mp="2zlli5ahfl0qy" />
          <InsidePages data-id="element-9" data-mp="2zmeo498kfm81" />
          <Bonuses data-id="element-10" data-mp="2zn69yscd25l4" />
          <HowItWorks data-id="element-11" data-mp="33mov9p83gioh" />
          <Audience data-id="element-12" data-mp="33m5bs42spm8c" />
          <Offer data-id="element-13" data-mp="33nges1of2pye" />
          <Guarantee data-id="element-14" data-mp="33mym1f0yqtv8" />
          <Testimonials data-id="element-15" data-mp="33oi1j3esp0vy" />
          <Faq data-id="element-16" data-mp="38l8idsyfc0if" />
          <FinalCta data-id="element-17" data-mp="38li619vzxvky" />
        </main>
        <Footer data-id="element-18" data-mp="38kgm0fx05yr3" />
      </div>
    </MotionConfig>;
}